import React, { Component } from 'react';
import { connect } from 'react-redux';
import actions from '../redux/actions';

class CreateDeal extends Component {
  render() {
    return <div className="create-deal">{this.props.children}</div>;
  }
}

const mapStateToProps = (state) => ({
  team: state.teams.selectedTeam,
});

const mapDispatchToProps = (dispatch) => ({
  resetAttribute: () => {
    dispatch(actions.resetAttribute());
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(CreateDeal);



// WEBPACK FOOTER //
// src/pages/CreateDeal.jsx